import Vue from 'vue'
import BaseModel from './BaseModel'
import qs from 'qs'
import cloneDeep from 'lodash.clonedeep'

class Model extends BaseModel {
    constructor(id) {
        super()
        this._dirty = false
        this.model = { id: id }
    }

    get url() {
        return this.id ? `${this.base}/${this.id}` : null
    }

    get link() {
        return this.url ? `/${this.url}` : null
    }

    get id() {
        return this._model?.id
    }

    get model() {
        return this._model || {}
    }

    set model(val) {
        this.reset()
        this._model = cloneDeep(val) || {}
    }

    updateModel(model) {
        this.model = cloneDeep(model)
    }

    fetch(_url = undefined, _params = undefined) {
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                let url = _url ? `${this.base}/${_url}` : this.base
                if (_params) {
                    const params = qs.stringify(
                        {
                            ..._params,
                        },
                        {
                            encode: true,
                            arrayFormat: Vue.prototype.$arrayFormat,
                        }
                    )
                    url = url + (params != '' ? `?${params}` : '')
                }

                window.debug.info(`Model fetch: ${url}`)
                this._client
                    .index(url)
                    .then((res) => {
                        this.reset()
                        this._loaded = true
                        this.updateModel(res)
                        return resolve(res)
                    })
                    .catch((e) => {
                        return reject(e)
                    })
                    .finally(() => {
                        this._loading = false
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }

    reset() {
        super.reset()
        this._model = {}
        this._dirty = false
    }

    save(_url, _model) {
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                let url = this.base
                let functionName = 'store'
                if (this.id) {
                    url = this.url
                    functionName = 'update'
                }
                if (_url) url = `${url}/${_url}`
                window.debug.info(`Model ${functionName}: ${url}`)
                this._client[functionName](url, typeof _model !== 'undefined' ? _model : this.model)
                    .then((res) => {
                        this._loaded = true
                        if (typeof _model === 'undefined') {
                            this.updateModel(res)
                        }
                        return resolve(res)
                    })
                    .catch((e) => {
                        return reject(e)
                    })
                    .finally(() => {
                        this._loading = false
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }

    destroy() {
        this._loading = true
        return new Promise((resolve, reject) => {
            try {
                window.debug.info(`Model destroy: ${this.url}`)
                this._client
                    .destroy(this.url, this.model)
                    .then((res) => {
                        this._loaded = true
                        this.updateModel(res)
                        return resolve(res)
                    })
                    .catch((e) => {
                        return reject(e)
                    })
                    .finally(() => {
                        this._loading = false
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }

    get isDirty() {
        return this._dirty
    }
}

export default Model
